import { PageContext } from "vike/types";

export function getPageTitle(pageContext: PageContext): string {
  return (pageContext.data as any)?.title || pageContext.config.title || "Project Green World";
}
